import React, {Component} from "react"
import PropTypes from "prop-types"
import {isString} from "lodash"
import styled from "styled-components"

import MDC from "@irati/utils/constants/markdown"
import {
  containsBulletPointList,
  beginsWithBulletPointList,
  getBulletPointListItems
} from "@irati/utils/markdown/index"
import Markdown from "@irati/ui/src/Markdown"
import {H5, H6} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"

import CircledConnector from "../../components/CircledConnector/CircledConnector"

const CONTENT_TYPE_MARKDOWN = "CONTENT_TYPE_MARKDOWN"
const CONTENT_TYPE_LIST = "CONTENT_TYPE_LIST"

const StyledCompanyBenefitContainer = styled.div`
  text-align: center;

  h3 {
    font-size: 30px;
    line-height: 35px;
  }
`

class TicketInstructions extends Component {
  static propTypes = {
    instructions: PropTypes.string,
    item: PropTypes.object
  };
  static defaultProps = {
    instructions: null,
    item: null
  };


  constructor(props) {
    super(props)
    this.state = {}
  }

  /**
   **** Matthew Rawson @ 10/08/2017 14:23 ***
   *
   * This is an agreed upon #hack to display the markdown content as required.
   * It's role is to return an array of objects. Each object describes what components should be displayed.
   *
   * The reason why this hack has been implemented is because snez wants the ability to have multiple numbered list
   * components as well as normal markdown.
   *
   * This method will separate all the paragraphs of markdown. It will then determine which of the paragraphs contain
   * lists.
   *
   * It assumes that the markdown contains double newline characters to denote different paragraphs.
   *
   * @param instructions
   * @returns {object[]} Array
   */
  splitListAndParagraphsFromInstructions(instructions) {
    const paragraphs = isString(instructions) ? instructions.split(MDC.NEW_PARAGRAPH_SEPARATOR) : []
    const structure = paragraphs.map((para) => {
      const isList = containsBulletPointList(para) && beginsWithBulletPointList(para)
      return {
        type: isList ? CONTENT_TYPE_LIST : CONTENT_TYPE_MARKDOWN,
        content: isList ? getBulletPointListItems(para) : para
      }
    })
    return structure
  }


  render() {
    const {item} = this.props
    const isCompanyBenefit = item && (item.type === DEAL_TYPE_COMPANY_BENEFITS)

    return (
      <span>
        {isCompanyBenefit &&
          <StyledCompanyBenefitContainer>
            <H5 marginBottom={1}><FormattedMessage id="perks.components.tickets.ticketInstructions.firstText" /></H5>
            <H6 marginBottom={1}><FormattedMessage id="perks.components.tickets.ticketInstructions.secondText" /></H6>
          </StyledCompanyBenefitContainer>
        }
        {this.splitListAndParagraphsFromInstructions(this.props.instructions).map((cs, index) => {
          let comp = null

          if (cs.type === CONTENT_TYPE_MARKDOWN) {
            comp = <Markdown key={index} className="tickets_markdown" source={cs.content} />
          } else {
            comp = <CircledConnector key={index} data={cs.content} />
          }

          return comp
        })}
      </span>
    )
  }
}

export default TicketInstructions
